<template>
  <section>
    <div class="upload-file">
      <div
        v-if="
          !editDisplay ||
          (uploadSuccess && !fileName) ||
          uploadSuccess === false
        "
      >
        <button class="upload-file-button" @click="openUppy">
          <img src="@/assets/images/upload_white_arrow.svg" class="upload-file-icon"/>
          <span class="upload-file-text">
            <span class="big-text"> {{ $t("SELECT_FILE") }} </span>
            <span>
              <span class="text">
                {{ $t("UPLOAD_OPTIONS") }}
              </span>
              <span
                class="text"
                v-for="(option, index) in allowedFileTypes"
                :key="index"
              >
                {{ option.substring(1) + "," }}
              </span>
              <span class="text">
                {{ $t("UP_TO") }} {{ maxUploadSize / 1000000 + "MB" }}
              </span>
            </span>
          </span>
        </button>
        <p class="error-text" v-if="uploadSuccess === false">
          {{ $t("FILE_UPLOAD_FAILED") }}
        </p>
      </div>
      <div class="uploaded-file" v-else>
        <div class="uploaded-file-container" @dblclick="downloadFile">
          <img :src="imgSrc" class="file-icon" />
          <p class="file-name">
            {{ name }}
          </p>
        </div>
        <button class="change-file hide" @click="openUppy">
          <img src="@/assets/images/return_arrow_icon.svg" class="return-icon"/>
          <span>{{ $t("CHANGE_FILE") }}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import { uploadConfig } from '@/constants'
import { getFileTypeIcon } from '@/utilityFunctions'

export default {
  name: 'file-upload-header',
  data () {
    return {
      editDisplay: false,
      name: null,
      type: null,
      allowedFileTypes: [
        '.doc',
        '.ppt',
        '.xls',
        '.csv',
        '.txt',
        '.pdf'
      ],
      maxUploadSize: uploadConfig.maxUploadSize
    }
  },
  computed: {
    ...mapState({
      fileName: state => state.uploads.uploadFile?.name,
      fileType: state => state.uploads.uploadFile?.type,
      uploadSuccess: state => state.uploads.uploadSuccess,
      uploadOptions: state => state.uploads.uploadOptions,
      selectedEntryOrigin: state => state.collections.selectedEntryOrigin,
      selectedEntry: state => state.collections.selectedEntry
    }),
    imgSrc () {
      if (this.selectedEntry) {
        return getFileTypeIcon(this.selectedEntry.data.metadata.fileType)
      } else {
        return getFileTypeIcon(this.fileType)
      }
    }
  },
  created () {
    // if we came from 'collectionEntry' then we need to display the selectedEntry data of file
    if (this.selectedEntryOrigin === 'collectionEntry') {
      this.editDisplay = true
      // TODO after DB is updated assign correct value to name and type
      this.name = this.selectedEntry.data.metadata.fileName
      this.type = this.selectedEntry.data.metadata.fileType
    }
  },
  watch: {
    uploadSuccess (newValue) {
    // if true its means that the name and type should be taken from fileObj that was updated
    // after success upload
      if (newValue) {
        this.editDisplay = true
        this.name = this.fileName
        this.type = this.fileType
      }
    }
  },
  methods: {
    openUppy () {
      this.$emit('openUppy', 'file')
    },
    downloadFile () {
      // TODO fix to correct id of file
      this.$store.dispatch('downloadContent', this.selectedEntry.data.id)
    }
  }
}
</script>

<style>

</style>
